import { Controller } from "@hotwired/stimulus"
import { CurrencyHelper } from "~/helpers/currency_helper"

export default class extends Controller {
  static targets = ["total", "callLimit"]
  static values = { creditPrice: Number, currency: String, limit: Number }

  connect() {
    this.updateCost()
  }

  updateCost() {
    let callLimit = 0

    if (this.callLimitTarget.value.length > 0) {
      callLimit =
        parseInt(this.callLimitTarget.value) > this.limitValue ? this.limitValue : parseInt(this.callLimitTarget.value)
    }

    this.totalTarget.textContent = CurrencyHelper.numberToCurrency(
      callLimit * this.creditPriceValue,
      this.currencyValue,
    )
  }
}
